import React from "react";

const HamBurger = () => {
  return (
    <div>
      <img src="./images/hamburger.png" alt="Hamburger" />
    </div>
  );
};

export default HamBurger;
